// extracted by mini-css-extract-plugin
export var path = "flowAnimation-module--path--sDD6N";
export var dash = "flowAnimation-module--dash--2nivy";
export var mobile_path = "flowAnimation-module--mobile_path--OfGLi";
export var mobileDash = "flowAnimation-module--mobileDash--facUQ";